import { render, staticRenderFns } from "./AudioPresentationModal.vue?vue&type=template&id=c0a9ec44"
import script from "./AudioPresentationModal.vue?vue&type=script&lang=js"
export * from "./AudioPresentationModal.vue?vue&type=script&lang=js"
import style0 from "./AudioPresentationModal.vue?vue&type=style&index=0&id=c0a9ec44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports